import React, { useState } from 'react';
import "./XR.css";
import Navbar from "../components/Navbar";

const Realtimecollaboration = () => {
  const [showMore, setShowMore] = useState(false);

  return (
    <>
      <Navbar />
      <div className="xr-container">
        <div className="xr-content">
          <p className="page-path">Services / Remote XR Collaboration</p>
          <h5 className="xr-title">Remote XR Collaboration</h5>
          <p className="subtitle">
            Enhance teamwork with immersive, real-time virtual environments
          </p>
          <p>
            Facilitate spatially connected collaboration through virtual rooms that support natural interaction, enabling seamless remote guidance, reviews, and planning sessions.
            <span className="know-toggle" onClick={() => setShowMore(!showMore)}>
              {showMore ? ' Know less' : ' Know more...'}
            </span>
          </p>

          {/* {showMore && (
            <p className="extra-text">
              These virtual environments integrate avatars, voice and video chat, and shared interactive tools to replicate in-person collaboration remotely, enhancing productivity and engagement.
            </p>
          )} */}

          <div className="xr-highlights">
            <h6>Highlights:</h6>
            <ul>
              <li>Virtual spaces with avatars, voice/video chat, and shared tools</li>
              <li>Real-time collaboration on documents and 3D models</li>
              <li>Use cases: design reviews, virtual classrooms, remote project planning</li>
            </ul>
          </div>
        </div>

        <div className="xr-image-wrapper">
          <img src="../images/page1image9.webp" alt="XR Workshop" className="xr-image" />
        </div>
      </div>
    </>
  );
};

export default Realtimecollaboration;
